import axios               from 'axios';
import { USER_SERVER_URL } from '@geenee/builder/src/api/AuthAPI';

export const getMatomoSitesApi = (matomo_domain: string, matomo_api_token: string) => axios.post(
    `${ USER_SERVER_URL }/api/server-cors`,
    { url: `${ matomo_domain }/?module=API&method=SitesManager.getSitesFromGroup&format=JSON&token_auth=${ matomo_api_token }` }
).then((res) => res.data);
